<template>
  <div class="seckill" v-if="today.length || tomorrow.length" mg-stat-show="flag=610" 
      mg-stat-lob="smod=seckill">
    <div class="header">
      <span :class="{ active: isActive }" @click="changeActive('5031', true)"
        >今日秒杀</span
      >
      <span
        :class="{ active: !isActive }"
        class="preview"
        @click="changeActive('5032', false)"
        v-if="tomorrow.length"
        >明日预告</span
      >
      <div class="remind">
        <span>秒杀提醒</span>
        <Reminder />
      </div>
    </div>
    <div
      class="today-goods"
      v-show="isActive"
      v-if="today.length"
    >
      <div
        class="good"
        v-for="(item, index) in today"
        :key="index"
        @click="clickJumpHW(item, 'today')"
      >
        <div class="good-image">
          <img :src="item.original_img" alt="" />
          <p class="stock">限量{{ item.flash_num }}件</p>
        </div>
        <p class="item-black-title">{{ item.goods_name }}</p>
        <p class="good-credits">
          <span>{{ item.flash_points }}</span
          >积分
          <span class="good-facePrice">{{ item.flash_price }}元</span>
        </p>
        <div class="btn-list">
          <button v-if="item.goodStatus == 1">
            {{ item.start | formatHour }}开抢
          </button>
          <button v-if="item.goodStatus == 0">正在秒杀</button>
          <button v-if="item.goodStatus == 2" class="good-snatch">
            已抢完
          </button>
          <button v-if="item.goodStatus == 3" class="good-over">已结束</button>
        </div>
      </div>
    </div>
    <div
      class="tomorrow-goods"
      v-show="!isActive"
      v-if="tomorrow.length"
    >
      <div
        class="good"
        v-for="(item, index) in tomorrow"
        :key="index"
        @click="clickJumpHW(item, 'tomorrow')"
      >
        <div class="good-image">
          <img :src="item.original_img" alt="" />
          <p class="stock">限量{{ item.flash_num }}件</p>
        </div>
        <p class="item-black-title">{{ item.goods_name }}</p>
        <p class="good-credits">
          <span>{{ item.flash_points }}</span
          >积分
          <span class="good-facePrice">{{ item.flash_price }}元</span>
        </p>
        <button>即将开抢</button>
      </div>
    </div>
  </div>
</template>
<script>
import Reminder from '@/v2-components/business/index/reminder'
import { getNewDBSeckillGoods, flashPointsGoods } from '@/utils/service'
import { loginMixin } from '@/utils/mixin'
import { zeroFill, getTimeStamp, getHaoWuUrl } from '@/utils/mUtil'

const KILL_STATUS = {
  ING: 0, // 正在秒杀
  WILL: 1, // 即将开抢
  NOT: 2, // 已抢完
  OVER: 3, // 已结束
}

export default {
  mixins: [loginMixin],
  data() {
    return {
      isActive: true,
      today: [],
      tomorrow: [],
    }
  },
  created() {
    this._getNewDBSeckillGoods()
  },
  methods: {
    changeActive(evt, val) {
      Report.click({
        value: JSON.stringify({
          evt,
          moduleid: '8',
        }),
      })
      this.isActive = val
    },
    async _getNewDBSeckillGoods() {
      try {
        // const data = await getNewDBSeckillGoods()
        const data = await flashPointsGoods()

        if (data.tomorrow) {
          this.tomorrow = data.tomorrow
        }
        if (data.today) {
          this.handleGood(data)
        }
      } catch (error) {
        console.log('flashPointsGoods', error)
      }
    },
    handleGood(data) {
      let now = getTimeStamp(data.now)
      let today = data.today
      today.forEach((v) => {
        v.start = getTimeStamp(v.flash_start_time)
        v.end = getTimeStamp(v.flash_end_time)
        if (now > v.start && now < v.end) {
          // 正在秒杀
          v.goodStatus = KILL_STATUS.ING
        } else if (now < v.start) {
          // 即将开抢
          v.goodStatus = KILL_STATUS.WILL
        } else {
          if (v.buy_num >= v.flash_num) {
            // 已抢完
            v.goodStatus = KILL_STATUS.NOT
          } else {
            // 已结束
            v.goodStatus = KILL_STATUS.OVER
          }
        }
      })

      // 正在秒杀
      const arrIng = today.filter((v) => v.goodStatus == KILL_STATUS.ING) || []

      // 即将开抢
      const arrWill =
        today.filter((v) => v.goodStatus == KILL_STATUS.WILL) || []

      // 已抢完
      const arrNot = today.filter((v) => v.goodStatus == KILL_STATUS.NOT) || []

      // 已结束
      const arrOver =
        today.filter((v) => v.goodStatus == KILL_STATUS.OVER) || []

      this.today = [...arrIng, ...arrWill, ...arrNot, ...arrOver]

      arrIng.length && this.$emit('isKillingNow')
    },
    clickJumpHW(item, type) {
      MgStat.send(
        'click',
        {
        },
        {
          cntp: 'score_newHome',
          mod: 'seckill',
          cont: '点击秒杀专区模块',
        }
      );

      location.href = getHaoWuUrl(item.goods_id, type, 'credits')
    },
  },
  name: 'SecKill',
  props: {},
  components: {
    Reminder,
  },
  filters: {
    formatHour(val) {
      const date = new Date(parseInt(val))
      return `${zeroFill(date.getHours())}:${zeroFill(date.getMinutes())}`
    },
  },
  computed: {
    tomorrowProids() {
      return this.tomorrow.map((v) => v.goods_id).join('#')
    },
    proids() {
      return this.today.map((v) => v.goods_id).join('#')
    },
  },
}
</script>
<style scoped lang="less">
.seckill {
  overflow: hidden;
  padding: 20px 0 28px;
  background: #fff;
  border-radius: 36px 36px 36px 36px;
  
  .header {
    padding-left: 30px;
    text-align: left;
    line-height: 48px;
    margin-bottom: 42px;
    position: relative;
    span {
      display: inline-block;
      vertical-align: top;
      // font-family: AlimamaFangYuanTiVF-Thin;
      font-weight: 600;
      font-size: 32px;
      color: rgba(0, 0, 0, 0.4);

      &.active {
        font-size: 34px;
        color: #ff5f00;
        position: relative;
        transition: all 0.2s;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -25px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #ff5f00;
          z-index: 88;
        }

        &::before {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          width: 18px;
          height: 18px;
          bottom: -28px;
          border-radius: 50%;
          background-color: #ff5f00;
          opacity: 0.2;
        }
      }
      &.preview {
        margin-left: 33px;
      }
    }
    .remind {
      position: absolute;
      right: 30px;
      top: 0;

      span {
        font-size: 24px;
        font-weight: 500;
        font-family: PingFangSC-Regular, sans-serif;
        color: rgba(0, 0, 0, 0.4);
      }
    }
  }
  .today-goods,
  .tomorrow-goods {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    padding-left: 30px;
  }
  .good {
    width: 300px;
    height: 450px;
    display: inline-block;
    vertical-align: top;
    border-radius: 12px;
    margin-right: 18px;
    background-color: #ffffff;

    .btn-list {
      .good-snatch,
      .good-over {
        opacity: 0.3;
      }
    }

    p {
      text-align: left;
      margin-left: 10px;
    }
    .good-image {
      position: relative;
      margin: 10px auto 16px;
      width: 280px;
      height: 240px;
      background-color: #f6f7f9;

      img {
        position: absolute;
        display: block;
        max-width: 70%;
        max-height: 70%;
        object-fit: cover;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
      }
      .stock {
        font-size: 20px;
        color: #ffffff;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        height: 36px;
        padding-left: 13px;
        background: linear-gradient(
          270deg,
          rgba(255, 158, 25, 0) 0%,
          rgba(254, 94, 44, 1) 100%
        );
        border-radius: 0px 0px 0px 1px;
        position: absolute;
        bottom: 0;
        margin-left: 0;
        width: 100%;
      }
    }
    .good-credits {
      font-size: 22px;
      color: #888888;
      margin-bottom: 22px;
      span {
        font-size: 32px;
        color: #ff5f00;
      }
      .good-facePrice {
        font-size: 20px;
        font-weight: 600;
        color: #cacaca;
        position: relative;
        &::after {
          content: '';
          width: 100%;
          background-color: #cacaca;
          height: 2px;
          position: absolute;
          left: 0;
          top: 50%;
        }
      }
    }
    button {
      width: 170px;
      height: 60px;
      background: linear-gradient(
        308deg,
        rgba(254, 94, 44, 1) 0%,
        rgba(255, 158, 25, 1) 100%
      );
      box-shadow: 0px 2px 12px 0px rgba(255, 136, 0, 0.35);
      border-radius: 30px;
      font-size: 26px;
      font-weight: bold;
      color: #ffffff;
      display: block;
      margin: 0 auto 25px auto;
    }
  }
}
</style>
